import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import {
  Dataset,
  Handyman,
  Inventory,
  MenuRounded as MenuIcon,
  People,
  RequestPage,
  WebAsset,
} from "@mui/icons-material";
import { useAppSelector } from "../../app/hooks";

enum Page {
  Catalog = "catalog",
  Contracts = "contracts",
  Datasets = "datasets",
  Employees = "employees",
  Requests = "requests",
  Tools = "tools",
}

function BarMenu() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const hasEmployees = useAppSelector(
    (state) => state.employees.items.length > 0
  );

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MenuIcon color="primary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {Object.values(Page).map((page) => {
          if (page === Page.Employees && !hasEmployees) {
            return null;
          }

          return (
            <MenuItem
              key={page}
              component={RouterLink}
              to={page}
              onClick={handleClose}
            >
              {pageContent(page)}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}

export default BarMenu;

function pageContent(page: string) {
  let content;

  switch (page) {
    case Page.Catalog: {
      content = (
        <ListItemIcon>
          <WebAsset color="disabled" />
        </ListItemIcon>
      );
      break;
    }

    case Page.Contracts: {
      content = (
        <ListItemIcon>
          <Inventory color="disabled" />
        </ListItemIcon>
      );
      break;
    }

    case Page.Datasets: {
      content = (
        <ListItemIcon>
          <Dataset color="disabled" />
        </ListItemIcon>
      );
      break;
    }

    case Page.Employees: {
      content = (
        <ListItemIcon>
          <People color="secondary" />
        </ListItemIcon>
      );
      break;
    }

    case Page.Requests: {
      content = (
        <ListItemIcon>
          <RequestPage color="primary" />
        </ListItemIcon>
      );
      break;
    }

    case Page.Tools: {
      content = (
        <ListItemIcon>
          <Handyman color="disabled" />
        </ListItemIcon>
      );
      break;
    }

    default:
      content = null;
  }

  return (
    <>
      {content}
      {page.charAt(0).toUpperCase() + page.slice(1)}
    </>
  );
}
